import { useToast } from '@cian/ui-kit';
import { useCallback } from 'react';

import { DYNAMIC_PHONE_ERROR_TEXT } from '../utils/dynamicCalltracking';

export function useDynamicPhoneErrorToast(): VoidFunction {
  const toast = useToast({ placement: 'top-right' });

  return useCallback(() => {
    toast.open({ type: 'error', text: DYNAMIC_PHONE_ERROR_TEXT });
  }, [toast]);
}
